import React from 'react'
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";
import menuActImg from "@/assets/svg/sidebar/menu_active.svg";
import menuImg from "@/assets/svg/sidebar/menu.svg";
import marketActImg from "@/assets/svg/sidebar/market_active.svg";
import marketImg from "@/assets/svg/sidebar/market.svg";
import earnImg from "@/assets/svg/sidebar/earn.svg";
import daoImg from "@/assets/svg/sidebar/dao.svg";
import { useLocation } from 'react-router-dom';

export default function Nav() {
  
  const location = useLocation();
  const toNoop = (e)=>{
    e.preventDefault();    
  }
  return (
    <NavWrapper>
      <div className='menus'>
        <NavLink exact="true" to="/" className='menu-item' >
          <ReactSVG className="menu-icon" src={location.pathname === '/' ? menuActImg : menuImg} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex') }}/>
          <span className='menu-text'>Dashboard</span>
        </NavLink>
        <NavLink activeclassname="active" to="/market" className='menu-item'>
          <ReactSVG className="menu-icon" src={location.pathname === '/market' ? marketActImg : marketImg} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex') }}/>
          <span>Market</span>
        </NavLink>
        <NavLink activeclassname="active" to="/Earn" className='menu-item' onClick={toNoop}>
          <ReactSVG className="menu-icon" src={earnImg} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex') }}/>
          <span className='gray-text'>Earn</span>
          <span className='soon-item'>soon</span>
        </NavLink>
        <NavLink activeclassname="active" to="/DAO" className='menu-item' onClick={toNoop}>
          <ReactSVG className="menu-icon" src={daoImg} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex') }}/>
          <span className='gray-text'>DAO</span>
          <span className='soon-item'>soon</span>
        </NavLink>
      </div>
    </NavWrapper>
    // 
  )
}

const NavWrapper = styled.div`
  height: 100%;
  padding-left: 33px;
  .menus{
    display: flex;
    flex-direction: column;
    margin-top:25px;
    .active{
      color:#32DE86;    
      font-weight : 600;
    }
  }
  .menu-item{    
    font-size: 16px;
    line-height: 26px;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 18px;
    .menu-icon{
      margin-right:18px;
    }
    .soon-item{
      padding-left:8px;
      font-weight: 400;
      font-size: 12px;
      color: #CAFF33;
    }
    & + .menu-item{
      margin-top:36px;
    }
    .gray-text{
      font-weight: 400;
      color: rgba(255, 255, 255, 0.3);
    }
  }  
  .nft-item{
    margin-left: -33px;
    margin-top: 36px;
    .nft-block{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .line{
        height: 25px;
        width: 3px;
        background: #32DE86;
      }
      .btn{
        width: 112px;
        height: 44px;
        line-height: 44px;
        background: #32DE86;
        border-radius: 8px;
        text-align: center;
        color: #fff;
        margin-left: 30px;
        margin-right: 12px;        
      }
      .txt{
        font-weight: 500;
        font-size: 12px;
        line-height: 17px;        
        color: #FF8A00;
      }
    }
  }
`;
